import { render, staticRenderFns } from "./CorporationC.vue?vue&type=template&id=73d6e618&scoped=true"
import script from "./CorporationC.vue?vue&type=script&lang=js"
export * from "./CorporationC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d6e618",
  null
  
)

export default component.exports